import { getIdReduxUtil } from '../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../redux/utils/get-path'
import { REFERENCES_DOMAIN } from '../../constants'
import { getObjectUtil, logUtil, omitObjectUtil } from 'packages/src'
import setUtil from '../../../../utils/set'

function deletePathReferenceUtil (params) {
  const {
    state,
    instance
  } = params
  const domain = getObjectUtil(state, REFERENCES_DOMAIN)
  const path = getPathReduxUtil(instance)
  if (!domain[path]) {
    return state
  }
  // Remove the instance from the referenced paths
  const newState = domain[path].reduce((updatedState, referencePath) => {
    let value = getObjectUtil(updatedState, referencePath)
    if (!value) {
      logUtil('').warn(`not found path ${path}, referencePath ${referencePath}`)
      return updatedState
    }
    // console.debug(`deletePathReferenceUtil: path ${path}, referencePath
    // ${referencePath}, value `, value)
    if (!Array.isArray(value)) {
      return setUtil(updatedState, referencePath, null)
    }
    // If it's an association, remove it from the instance referencing it
    value = value.filter(elem => getIdReduxUtil(elem) !==
      getIdReduxUtil(instance))
    return setUtil(updatedState, referencePath, value)
  }, state)
  return {
    ...newState,
    [REFERENCES_DOMAIN]: omitObjectUtil(domain, [path])
  }
}

export default deletePathReferenceUtil
